import { countries } from 'countries-list'

export const getCountries = () => {
  const countryList = []
  const regionNames = new Intl.DisplayNames(['de'], { type: 'region' })
  Object.keys(countries).map(code => countryList.push(regionNames.of(code)))

  const priority = ['Deutschland', 'Österreich']

  const sortedCountryList = countryList.sort((a, b) => {
    const aIndex = priority.indexOf(a)
    const bIndex = priority.indexOf(b)

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex // both are priority
    }
    if (aIndex !== -1) return -1 // a is priority
    if (bIndex !== -1) return 1 // b is priority

    return a.localeCompare(b) // normal alphabetical
  })
  return sortedCountryList
}
